import React from "react";
import { Heart } from "lucide-react";

/* BuiltInIndiaBand — patriotic Unstop-style banner.
 * Tri-colour gradient stripe with a one-line statement of intent. Sits
 * between the gamification strip and the footer. */

export default function BuiltInIndiaBand() {
  return (
    <section className="bg-white border-t border-rule" data-testid="built-in-india-band">
      <div className="max-w-7xl mx-auto px-6 py-10 sm:py-12 text-center">
        <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full"
             style={{ background: "linear-gradient(90deg, #FF9933 0%, #FFFFFF 50%, #138808 100%)" }}>
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-ink">
            🇮🇳 Built in India
          </span>
        </div>
        <h3 className="font-display h-display text-2xl sm:text-3xl lg:text-4xl text-ink">
          Built in India.
          {" "}
          <span style={{ background: "linear-gradient(90deg, #FF6B35 0%, #9933FF 100%)",
                         WebkitBackgroundClip: "text",
                         WebkitTextFillColor: "transparent",
                         backgroundClip: "text" }}>
            For the world.
          </span>
        </h3>
        <p className="mt-4 text-sm sm:text-base text-muted max-w-2xl mx-auto leading-relaxed">
          A Tech Catalyst initiative bridging India&apos;s student pool, lateral talent, institutions,
          and global employers. Designed in Pune, deployed at every campus that&apos;ll have us.
        </p>
        <div className="mt-5 inline-flex items-center gap-1.5 text-xs text-muted">
          <span>Made with</span>
          <Heart size={13} className="text-energy fill-energy" />
          <span>by SkillConnect &amp; Tech Catalyst</span>
        </div>
      </div>
    </section>
  );
}
